<template>
  <span :class="spanClass">
    <svg viewBox="0 0 24 24" :width="svgSize" :height="svgSize" class="inline-block">
      <path fill="currentColor" :d="path" />
    </svg>
    <update-mark :color="updateMark" :tr="updateMarkTr"/>
  </span>
</template>

<script>
import { computed } from 'vue'
import UpdateMark from '@/components/ui/data-display/UpdateMark.vue'
import { useIconSize } from '@/composables/useIconSize'

export default {
  name: 'Icon',
  components: {
    UpdateMark
  },
  props: {
    path: {
      required: true
    },
    w: String,
    h: String,
    size: [String, Number],
    updateMark: String,
    updateMarkTr: String,
    class: String,
  },
  setup (props) {
    const { spanClass, svgSize } = useIconSize(props)

    return {
      spanClass,
      svgSize
    }
  }
}
</script>
